import { PhotoGallery } from '@/model';
import {
  GetMediaPhotoGalleryByIdResponse,
  GetMediaPhotoGalleryItemResponse,
  GetMediaPhotoGalleryResponse,
  PostMediaPhotoGalleryResponse,
  PutMediaPhotoGalleryResponse,
} from '@/services/response/photo-gallery';

export class PhotoGalleryConverter {
  static toDomainFromGetItemResponse(response: GetMediaPhotoGalleryItemResponse): PhotoGallery {
    return {
      uuid: response.uuid,
      status: response.status,
      credit: response.credit,
      image_url: response.image_url,
      title: response.title,
      description: response.description,
      order: response.order,
      created_at: response.created_at,
      updated_at: response.updated_at,
      team_uuid: response?.team_uuid,
      team_name: response?.team_name,
      team_image: response?.team_image,
      business_unit_uuid: response.business_unit_uuid,
    };
  }

  static toDomainFromPaginatedResponse(response: GetMediaPhotoGalleryResponse): PhotoGallery[] {
    return response.data.map(PhotoGalleryConverter.toDomainFromGetItemResponse);
  }

  static toDomainFromPostResponse(response: PostMediaPhotoGalleryResponse): PhotoGallery {
    return {
      uuid: response.uuid,
      status: response.status,
      image_url: response.image_url,
      credit: response.credit,
      title: response.title,
      description: response.description,
      order: response.order,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromByIdResponse(response: GetMediaPhotoGalleryByIdResponse): PhotoGallery {
    return {
      uuid: response.uuid,
      status: response.status,
      image_url: response.image_url,
      credit: response.credit,
      title: response.title,
      description: response.description,
      team_uuid: response?.team_uuid,
      team_name: response?.team_name,
      team_image: response?.team_image,
      order: response.order,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromPutResponse(response: PutMediaPhotoGalleryResponse): PhotoGallery {
    return {
      uuid: response.uuid,
      status: response.status,
      image_url: response.image_url,
      credit: response.credit,
      title: response.title,
      description: response.description,
      order: response.order,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }
}
